import { consultar } from 'helpers/api';
//import { AppHelper } from 'helpers/AppHelper';

const controller = "fin-faturas";

export const FinFaturasService = {
   create,
   regerar,
   cancelar,
   baixar,
   get,
   ultimas,
   pesquisar,
   getCarne,
   ultimosCarnes,
   pesquisarCarne,
}

//--- Acoes sobre faturas --------------------------------------------
async function create(params) {
   return await consultar(`/${controller}/add.json`, 'post', params);
}

async function regerar(params) {
   return await consultar(`/${controller}/regerarCobranca.json`, 'post', params);
}

async function cancelar(id, motivo) {
   return await consultar(`/${controller}/cancelar.json`, 'post', { fin_fatura_id: id, motivo });
}

async function baixar(id, motivo) {
   return await consultar(`/${controller}/baixar.json`, 'post', { fin_fatura_id: id, motivo });
}

//--- Faturas --------------------------------------------
async function get(id) {
   return await consultar(`/${controller}/view/${id}.json`, 'get');
}

async function ultimas(dias) {
   return await consultar(`/${controller}/ultimas/${dias}.json`, 'get');
}

async function pesquisar(termo) {
   return await consultar(`/${controller}/pesquisar/${termo}.json`, 'get');
}

//--- Carnes --------------------------------------------
async function getCarne(id) {
   return await consultar(`/${controller}/view-carne/${id}.json`, 'get');
}

async function ultimosCarnes(dias) {
   return await consultar(`/${controller}/ultimos-carne/${dias}.json`, 'get');
}

async function pesquisarCarne(termo) {
   return await consultar(`/${controller}/pesquisar-carnes/${termo}.json`, 'get');
}
